import { render, staticRenderFns } from "./DraggableAlbumTable.vue?vue&type=template&id=0947d642"
import script from "./DraggableAlbumTable.vue?vue&type=script&lang=js"
export * from "./DraggableAlbumTable.vue?vue&type=script&lang=js"
import style0 from "./DraggableAlbumTable.vue?vue&type=style&index=0&id=0947d642&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports